var _path, _path2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIexWhiteLogoOnlyImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 400,
    height: 279,
    viewBox: "0 0 400 279",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M346.592 149.256L321.224 192.388L317.936 197.937L342.657 239.776H400L346.592 149.256ZM346.621 126.091L398.003 39.0355H340.368L317.936 77.1166L321.224 82.6953L346.621 126.091Z",
    fill: "url(#paint0_linear_241_27)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M316.966 98.6544L316.966 98.6529L312.588 91.1681L311.115 88.6495L311.042 88.5259L288.281 49.6201L259.037 0H201.402L224.511 39.0414H224.227L282.439 137.399L233.782 219.722L199.112 278.371H256.748L279.564 239.77H279.57L311.115 186.435L339.791 137.685L316.966 98.6544Z",
    fill: "url(#paint1_linear_241_27)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M51.3273 39.0414V239.771H0V39.0414H51.3273Z",
    fill: "url(#paint2_linear_241_27)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M211.904 191.596V239.771H82.8651V39.0414H210.471V86.9304H134.195V114.745H203.303V162.059H134.195V191.596H211.904Z",
    fill: "url(#paint3_linear_241_27)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_241_27",
    x1: 358.968,
    y1: 39.0355,
    x2: 358.968,
    y2: 239.776,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CCCCCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_241_27",
    x1: 282.021,
    y1: 4.05258,
    x2: 232.609,
    y2: 284.278,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#5F11EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#5A3293"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_241_27",
    x1: 25.6637,
    y1: 39.0414,
    x2: 25.6637,
    y2: 239.771,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CCCCCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_241_27",
    x1: 147.385,
    y1: 39.0414,
    x2: 147.385,
    y2: 239.771,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CCCCCC"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIexWhiteLogoOnlyImg);
export default __webpack_public_path__ + "static/media/iex-white-logo-only-img.ea9b51eab26851cbb580e2d9bba6f719.svg";
export { ForwardRef as ReactComponent };